const LOCAL_STORAGE_WISHLIST_KEY = "boucle-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active-wishlist";
const GRID_LOADED_CLASS = "";

const selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  productCard: "[data-product]",
};

document.addEventListener("DOMContentLoaded", () => {
  initButtons();
  initGrid();
  initWishlistClear();
  initWishlistCount();
  initWishlistHeaderCount();
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  console.log("[Shopify Wishlist] Wishlist Updated ✅", event.detail.wishlist);
  initGrid();
  initWishlistHeaderCount();
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Product List Loaded ✅",
    event.detail.wishlist
  );
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  console.log(
    "[Shopify Wishlist] Wishlist Buttons Loaded ✅",
    event.detail.wishlist
  );
});

const fetchProductCardHTML = async (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  const res = await fetch(productTileTemplateUrl);
  const resText = await res.text();

  if (!res.ok) {
    removeFromWishlist(handle);
    // remove product from wishlist
    return false;
  }

  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(resText, "text/html");
  const productCard = htmlDocument.documentElement.querySelector(
    selectors.productCard
  );
  return productCard.outerHTML;
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);

  const falseResponses = [];
  responses.forEach((response, index) => {
    if (!response) falseResponses.push(wishlist[index]);
  });

  if (falseResponses.length > 0) {
    alert(
      `Er zijn ${falseResponses.length} ${
        falseResponses.length > 1 ? "producten" : "product"
      } niet meer beschikbaar. Deze zijn verwijderd uit je verlanglijst.`
    );
  }

  const wishlistProductCards = responses.join("");
  grid.innerHTML = wishlistProductCards;

  const event = new CustomEvent("shopify-wishlist:init-product-grid", {
    detail: { wishlist: wishlist },
  });

  initButtons();
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    const productListener = button.dataset.listener || false;
    if (!productHandle) {
      return console.error(
        "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    }

    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    }

    if (!productListener || productListener === "false") {
      button.dataset.listener = true;
      button.addEventListener("click", () => {
        updateWishlist(productHandle);
        button.classList.toggle(BUTTON_ACTIVE_CLASS);
      });
    }
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];

  if (buttons.length) {
    setupButtons(buttons);
  } else {
    return;
  }

  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const initWishlistClear = () => {
  const clearButton = document.querySelector("[wishlist-clear]");
  if (clearButton)
    clearButton.addEventListener("click", () => {
      resetWishlist();
      initGrid();
      initButtons();
      initWishlistCount();
    });
};

const initWishlistCount = () => {
  const wishlist = getWishlist();
  const wishlistCount = wishlist.length;
  const wishlistCountElement = document.querySelector("[wishlist-count]");
  if (wishlistCountElement && (wishlistCount === 0 || wishlistCount > 1))
    wishlistCountElement.innerText = wishlistCount + " producten";
  else if (wishlistCountElement && wishlistCount === 1)
    wishlistCountElement.innerText = wishlistCount + " product";
};

const initWishlistHeaderCount = () => {
  const wishlist = getWishlist();
  const wishlistCount = wishlist.length;
  const wishlistCountElement = document.querySelectorAll(
    "[wishlist-header-count]"
  );

  wishlistCountElement.forEach((element) => {
    if (element) element.innerText = wishlistCount;
  });
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  initWishlistCount();

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const removeFromWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) return;
  wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const resetWishlist = () => {
  return setWishlist([]);
};

// const showToast = () => {
//   const portal = document.querySelector("#toasts");

// }
